export default {
    mx: {
        required: "district",
    },
};
